import { render, staticRenderFns } from "./CourseRecordOverviewDetail.vue?vue&type=template&id=0f7f713d"
import script from "./CourseRecordOverviewDetail.vue?vue&type=script&lang=js"
export * from "./CourseRecordOverviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports